import styles from './ProductFilter.module.scss';
import classNames from 'classnames';
import { Button, MultiNumberRange, GridCell } from 'ui/components';
import { useContext, useState } from 'react';
import { DictionaryContext } from 'application/adapters/context/Dictionary';

export interface ProductFilterProps {
	className?: string;
	filters: {
		priceRange: [number, number];
	};
	setFilters: (value: { priceRange: [number, number] }) => void;
	filterSettings: {
		priceRangeMinMax: [number, number];
	};
}

export const ProductFilter: React.FC<ProductFilterProps> = ({ className, filters, setFilters, filterSettings }) => {
	const [filterVisible, setFiltervisible] = useState(false);
	const dictionary = useContext(DictionaryContext);

	let timeout;
	const priceRangeUpdate = (priceRange: [number, number]) => {
		clearTimeout(timeout);
		timeout = setTimeout(() => {
			setFilters({
				...filters,
				priceRange,
			});
		}, 500);
	};

	const toggleFilter = () => {
		setFiltervisible(!filterVisible);
	};

	return (
		<div className={classNames(styles.ProductFilter, className)}>
			<Button className={styles.ProductFilter_controller} style="secondary" onClick={toggleFilter}>
				{filterVisible ? dictionary.getValue('Actions.Close', null, 'Close') : dictionary.getValue('Actions.Open', null, 'Open')}
				&nbsp;
				{dictionary.getValue('Product.Filters', null, 'filters')}
			</Button>
			{filterVisible && (
				<div className={styles.ProductFilter_wrapper}>
					<GridCell desktopWidth="33" mobileWidth="100">
						<MultiNumberRange
							min={filterSettings.priceRangeMinMax[0]}
							max={filterSettings.priceRangeMinMax[1]}
							callback={priceRangeUpdate}
						/>
					</GridCell>
				</div>
			)}
		</div>
	);
};
